var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import { useIntersectionObserver } from '@themes/common/components';
import LoadSwiperJS, { SwiperInjectStyles } from '@themes/common/lazy-swiper';
import EmptyCard from '../EmptyCard';
import ShopifyAjaxApi from '@themes/common/shopifyApi';
import { PRODUCT_RECOMMENDATIONS_BY_IDS } from '@commons/graphql/storefront/product';
import ProductItem from '@themes/common/components/ProductItem';
const commaSplit = (data) => { var _a; return ((_a = data === null || data === void 0 ? void 0 : data.toString().split(',')) !== null && _a !== void 0 ? _a : []).filter((f) => !!f); };
const hiddenProduct = (product) => { var _a, _b; return ((_a = product.tags) === null || _a === void 0 ? void 0 : _a.includes('hidden')) || ((_b = product.tags) === null || _b === void 0 ? void 0 : _b.includes('ignore')); };
function RecomendationItem({ product }) {
    return (_jsx("swiper-slide", { children: _jsx(ProductItem, Object.assign({}, product)) }));
}
function Recomendation({ items = [], styleButtonText, styleButtonLink, heading, styleHeader, styleContents, prevNextButtons, autoPlay, }) {
    const dragging = useRef(false);
    const recommendationRowElement = useRef(null);
    const renderItems = useMemo(() => items.length
        ? items.map((item, index) => _jsx(RecomendationItem, { product: item, isDragging: dragging }, item.id))
        : [1, 2, 3, 4, 5, 6, 7, 8].map((key) => (_jsx("swiper-slide", { children: _jsx(EmptyCard, {}) }, `${key}`))), [items]);
    const styleButtonTextComponent = styleButtonText && styleButtonLink && (_jsx("a", Object.assign({ href: styleButtonLink, className: 'button-primary carousel--button', title: styleButtonText }, { children: styleButtonText })));
    useEffect(() => {
        if (recommendationRowElement.current) {
            const swiper_container = $(recommendationRowElement.current).find('swiper-container')[0];
            Object.assign(swiper_container, {
                injectStyles: SwiperInjectStyles,
            });
            swiper_container === null || swiper_container === void 0 ? void 0 : swiper_container.initialize();
        }
    }, [items]);
    return (_jsxs(_Fragment, { children: [heading && _jsx("h2", Object.assign({ className: 'product-section--title product-recommendations--title' }, { children: heading })), _jsx("div", Object.assign({ className: 'page__container' }, { children: _jsxs("div", Object.assign({ className: 'carousel--wrapper' }, { children: [_jsxs("div", Object.assign({ className: 'carousel--text-content' }, { children: [styleHeader && _jsx("h4", Object.assign({ className: 'carousel--text-content-title' }, { children: styleHeader })), styleContents && (_jsx("div", { className: 'carousel--text-content-contents', dangerouslySetInnerHTML: {
                                        __html: styleContents,
                                    } })), styleButtonTextComponent] })), _jsx("div", Object.assign({ className: clsx({
                                'skeleton-wrapper': items.length === 0,
                            }) }, { children: _jsx("div", { children: _jsx("div", Object.assign({ className: 'recommendation--row', ref: recommendationRowElement }, { children: _jsx("swiper-container", Object.assign({ "slides-per-view": 'auto', navigation: prevNextButtons ? 'true' : undefined, loop: 'true', autoplay: autoPlay ? 'true' : undefined, init: 'false' }, { children: renderItems })) })) }) })), styleButtonTextComponent] })) }))] }));
}
function RecomendationComponent({ renderedElement, data, rootRender }) {
    const [stateItems, setItems] = useState([]);
    useEffect(() => {
        const objectIDs = commaSplit(data.ids);
        const metafieldObjectIDs = commaSplit(data.metafieldIds);
        const collectionObjectIDs = commaSplit(data.collectionIds);
        const initialize = (data, element) => __awaiter(this, void 0, void 0, function* () {
            yield LoadSwiperJS();
            const productIds = metafieldObjectIDs.map((id) => id.split('-')[0]);
            const reccomendedProductIds = objectIDs.map((id) => id.split('-')[0]);
            const searchResult = yield ShopifyAjaxApi.StorefrontQuery(PRODUCT_RECOMMENDATIONS_BY_IDS(productIds, reccomendedProductIds, collectionObjectIDs), Object.assign({}, (collectionObjectIDs.length
                ? {
                    first: (data.recommendationLimit || 10) * 3,
                    filters: [
                        {
                            available: true,
                        },
                    ],
                }
                : {})));
            const results = searchResult.data;
            const collectionProducts = Object.keys(results)
                .filter((key) => key.startsWith('collection_'))
                .map((key) => results[key])
                .flatMap((collection) => collection.products.nodes)
                .filter((p) => !hiddenProduct(p));
            const productProducts = Object.keys(results)
                .filter((key) => key.startsWith('product_'))
                .map((key) => results[key])
                .filter((p) => !hiddenProduct(p));
            const relatedProducts = Object.keys(results)
                .filter((key) => key.startsWith('related_'))
                .map((key) => results[key])
                .flat()
                .filter((p) => !hiddenProduct(p));
            const complementaryProducts = Object.keys(results)
                .filter((key) => key.startsWith('complementary_'))
                .map((key) => results[key])
                .flat()
                .filter((p) => !hiddenProduct(p));
            setItems([...collectionProducts, ...productProducts, ...relatedProducts, ...complementaryProducts]);
        });
        initialize(data, renderedElement);
    }, [renderedElement, data]);
    useEffect(() => {
        if (stateItems.length && data) {
            rootRender(_jsx(Recomendation, Object.assign({}, data, { items: stateItems })));
        }
    }, [stateItems, data, renderedElement, rootRender]);
    return _jsx(_Fragment, {});
}
function InterSectionComponent({ renderedElement, data, rootRender }) {
    const [ref, show] = useIntersectionObserver(true, {
        threshold: 0.1,
        rootMargin: '900px',
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: ref }), show && _jsx(RecomendationComponent, { data: data, renderedElement: renderedElement, rootRender: rootRender })] }));
}
export default InterSectionComponent;
